// Expose a scrollDownHero function for the scroll button
window.scrollDownHero = function () {
  var hero = document.querySelector('.lego-hero-container');
  if (!hero) return;

  var parentSection = hero.closest('[id^="shopify-section-"]');
  if (!parentSection) return;

  var next = parentSection.nextElementSibling;
  if (!next) return;

  next.scrollIntoView({ behavior: 'smooth' });
};

document.addEventListener('DOMContentLoaded', () => {
  const heroContainers = Array.from(document.querySelectorAll('.lego-hero-container'));
  if (!heroContainers.length) return;

  const MATTER_RETRY_MAX = 40;
  const MATTER_RETRY_DELAY_MS = 50;

  function getContentReservePx(heroRoot) {
    const content = heroRoot.querySelector('.lego-hero-content');
    if (!content || !window.matchMedia('(max-width: 800px)').matches) return 0;
    return Math.ceil(content.getBoundingClientRect().height + 16);
  }

  function getElementSize(el) {
    const width = Math.max(el.offsetWidth, el.getBoundingClientRect().width, 1);
    const height = Math.max(el.offsetHeight, el.getBoundingClientRect().height, 1);
    return { width, height };
  }

  function elementsHaveDimensions(physicsLayer, matterElems) {
    if (physicsLayer.clientWidth <= 0 || physicsLayer.clientHeight <= 0) return false;
    return matterElems.every((el) => {
      const { width, height } = getElementSize(el);
      return width > 0 && height > 0;
    });
  }

  function waitForMatter(callback, attempt = 0) {
    if (typeof Matter !== 'undefined') {
      callback(true);
      return;
    }
    if (attempt >= MATTER_RETRY_MAX) {
      callback(false);
      return;
    }
    setTimeout(() => waitForMatter(callback, attempt + 1), MATTER_RETRY_DELAY_MS);
  }

  function bootLegoHero(heroRoot) {
    const matterBox = heroRoot.querySelector('.matter-box');
    const physicsLayer = heroRoot.querySelector('.lego-hero-physics-layer') || matterBox;
    if (!matterBox || !physicsLayer) return;

    let matterElems = Array.from(physicsLayer.querySelectorAll('.dm-matter-elem'));

    function setHeroPointerDown(on) {
      heroRoot.classList.toggle('lego-hero--pointer-down', Boolean(on));
    }

    const isInteractiveTarget = (target) =>
      Boolean(target && target.closest && target.closest('.lego-hero-content a, .lego-hero-content button'));

    physicsLayer.addEventListener('mousedown', (event) => {
      if (isInteractiveTarget(event.target)) return;
      setHeroPointerDown(true);
    });
    physicsLayer.addEventListener(
      'touchstart',
      (event) => {
        if (isInteractiveTarget(event.target)) return;
        setHeroPointerDown(true);
      },
      { passive: true },
    );
    window.addEventListener('mouseup', () => setHeroPointerDown(false));
    window.addEventListener('touchend', () => setHeroPointerDown(false));
    window.addEventListener('touchcancel', () => setHeroPointerDown(false));
    window.addEventListener('blur', () => setHeroPointerDown(false));

    heroRoot.querySelectorAll('.lego-hero-content a, .lego-hero-content button').forEach((control) => {
      control.addEventListener('touchstart', (event) => event.stopPropagation(), { passive: true });
      control.addEventListener('mousedown', (event) => event.stopPropagation());
      control.addEventListener('click', (event) => event.stopPropagation());
    });

    waitForMatter((matterReady) => {
      if (!matterReady) return;

      const { Engine, Runner, Bodies, Composite, MouseConstraint, Mouse, Events } = Matter;

      const engine = Engine.create({
        enableSleeping: true,
        positionIterations: 4,
        velocityIterations: 3,
        constraintIterations: 1,
      });

      const isDesktop = () => window.matchMedia('(min-width: 1024px)').matches;
      const MAX_BRICK_ELEMENTS = 96;

      if (isDesktop()) {
        const originalElems = Array.from(physicsLayer.querySelectorAll('.dm-matter-elem'));
        if (originalElems.length > 0 && originalElems.length * 2 <= MAX_BRICK_ELEMENTS) {
          originalElems.forEach((el) => {
            const clone = el.cloneNode(true);
            clone.classList.add('dm-matter-elem');
            physicsLayer.appendChild(clone);
          });
        }
      }

      matterElems = Array.from(physicsLayer.querySelectorAll('.dm-matter-elem'));

      function prepareElements() {
        matterElems.forEach((el) => {
          el.style.display = 'block';
          el.style.left = '0';
          el.style.top = '0';
          el.style.transformOrigin = 'center center';
        });
      }

      function createBodies() {
        const boxWidth = physicsLayer.clientWidth;
        const boxHeight = physicsLayer.clientHeight;
        const topReserve = getContentReservePx(heroRoot);
        const minCenterY = topReserve;

        return matterElems.map((el) => {
          const { width: w, height: h } = getElementSize(el);
          const x = Math.random() * Math.max(boxWidth - w, 0) + w / 2;
          const spawnMin = minCenterY + h / 2;
          const spawnMax = Math.max(boxHeight - h / 2, spawnMin);
          const y = spawnMin + Math.random() * Math.max(spawnMax - spawnMin, 0);
          const angle = Math.random() * 2 * Math.PI;
          const body = Bodies.rectangle(x, y, w, h, {
            density: 0.01,
            friction: 0.1,
            restitution: 0.5,
            angle: angle,
            render: { opacity: 0 },
            frictionAir: 0.03,
            sleepThreshold: 40,
          });
          body._halfW = w / 2;
          body._halfH = h / 2;
          Composite.add(engine.world, body);
          return body;
        });
      }

      function createBoundaries() {
        const w = physicsLayer.clientWidth;
        const h = physicsLayer.clientHeight;
        const thickness = 10;
        const topReserve = getContentReservePx(heroRoot);
        const walls = [
          Bodies.rectangle(w / 2, h + thickness / 2, w, thickness, { isStatic: true, render: { opacity: 0 } }),
          Bodies.rectangle(w / 2, -thickness / 2, w, thickness, { isStatic: true, render: { opacity: 0 } }),
          Bodies.rectangle(-thickness / 2, h / 2, thickness, h, { isStatic: true, render: { opacity: 0 } }),
          Bodies.rectangle(w + thickness / 2, h / 2, thickness, h, { isStatic: true, render: { opacity: 0 } }),
        ];
        if (topReserve > 0) {
          walls.push(
            Bodies.rectangle(w / 2, topReserve, w, thickness, { isStatic: true, render: { opacity: 0 } }),
          );
        }
        Composite.add(engine.world, walls);
      }

      const runner = Runner.create({
        delta: 1000 / 60,
        maxFrameTime: 1000 / 50,
        maxUpdates: 2,
      });
      const mouse = Mouse.create(physicsLayer);
      let mouseConstraint = null;
      let elemBodies = [];
      let simulationRunning = false;
      let isSectionVisible = true;
      let pendingRebuild = false;
      let physicsInitialized = false;

      function syncDomFromBodies() {
        elemBodies.forEach((body, i) => {
          const el = matterElems[i];
          if (!el || !body) return;
          el.style.display = 'block';
          const hw = body._halfW;
          const hh = body._halfH;
          el.style.left = `${body.position.x - hw}px`;
          el.style.top = `${body.position.y - hh}px`;
          el.style.transform = `rotate(${body.angle}rad)`;
        });
      }

      function canRebuildPhysics() {
        return physicsLayer.clientWidth > 0 && physicsLayer.clientHeight > 0;
      }

      function addMouseConstraint() {
        if (!mouseConstraint) {
          mouseConstraint = MouseConstraint.create(engine, {
            mouse,
            constraint: { stiffness: 0.2, render: { visible: false } },
          });
          Composite.add(engine.world, mouseConstraint);
        }
        ['wheel', 'mousewheel', 'DOMMouseScroll'].forEach((evt) =>
          mouse.element.removeEventListener(evt, mouse.mousewheel),
        );
      }

      function removeMouseConstraint() {
        if (mouseConstraint) {
          Composite.remove(engine.world, mouseConstraint);
          mouseConstraint = null;
        }
      }

      Events.on(engine, 'afterUpdate', () => {
        syncDomFromBodies();
      });

      function rebuildPhysicsWorld() {
        if (!canRebuildPhysics()) {
          pendingRebuild = true;
          return;
        }
        pendingRebuild = false;
        removeMouseConstraint();
        Composite.clear(engine.world, false);
        matterElems = Array.from(physicsLayer.querySelectorAll('.dm-matter-elem'));
        prepareElements();
        createBoundaries();
        elemBodies = createBodies();
        addMouseConstraint();
        syncDomFromBodies();
        physicsInitialized = true;
      }

      function startSimulation() {
        if (!physicsInitialized) return;
        if (pendingRebuild || !elemBodies.length) {
          rebuildPhysicsWorld();
        } else {
          syncDomFromBodies();
        }
        if (!simulationRunning) {
          Runner.run(runner, engine);
          simulationRunning = true;
        }
      }

      function stopSimulation() {
        if (simulationRunning) {
          Runner.stop(runner);
          simulationRunning = false;
        }
      }

      function initPhysicsWorld() {
        prepareElements();
        if (!elementsHaveDimensions(physicsLayer, matterElems)) return;
        createBoundaries();
        elemBodies = createBodies();
        addMouseConstraint();
        physicsInitialized = true;
        startSimulation();
      }

      function waitForLayout(attempt = 0) {
        prepareElements();

        if (elementsHaveDimensions(physicsLayer, matterElems)) {
          initPhysicsWorld();
          return;
        }

        if (attempt >= 30) return;

        requestAnimationFrame(() => waitForLayout(attempt + 1));
      }

      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          if (!isSectionVisible) {
            pendingRebuild = true;
            return;
          }
          rebuildPhysicsWorld();
        }, 150);
      });

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              isSectionVisible = true;
              startSimulation();
            } else {
              isSectionVisible = false;
              stopSimulation();
            }
          });
        },
        { threshold: 0.1 },
      );

      observer.observe(physicsLayer);
      waitForLayout();
    });
  }

  heroContainers.forEach(bootLegoHero);
});
